export const GET_APPOINTMENT_LIST = 'GET_APPOINTMENT_LIST'
export const GET_ALL_APPOINTMENT_LIST = 'GET_ALL_APPOINTMENT_LIST'
export const FAILED_APPOINTMENT_LIST = 'FAILED_APPOINTMENT_LIST'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
export const SET_CURRENT_APPOINTMENT_DATE = 'SET_CURRENT_APPOINTMENT_DATE'
export const GET_APPOINTMENT_LIST_WO_PAGINATION = 'GET_APPOINTMENT_LIST_WO_PAGINATION'
